export enum Orientation {
  landscape = 'landscape',
  landscapePrimary = 'landscape-primary',
  landscapeSecondary = 'landscape-secondary',
  portrait = 'portrait',
  portraitPrimary = 'portrait-primary',
}
